// src/lib/logger.ts
type LogLevel = 'debug' | 'info' | 'warn' | 'error';

// Check if we're in production
const isProduction = import.meta.env.MODE === 'production';

// You can add more granular control with an environment variable
const loggingEnabled = isProduction 
  ? import.meta.env.VITE_ENABLE_LOGS === 'true' 
  : true;

// Optionally, specify which levels are allowed in production
const productionLevels: LogLevel[] = ['warn', 'error'];

class Logger {
  private static shouldLog(level: LogLevel): boolean {
    if (!loggingEnabled) return false;
    if (isProduction && !productionLevels.includes(level)) return false;
    return true;
  }

  static debug(...args: any[]): void {
    if (this.shouldLog('debug')) {
      console.debug('[DEBUG]', ...args);
    }
  }

  static info(...args: any[]): void {
    if (this.shouldLog('info')) {
      console.info('[INFO]', ...args);
    }
  }

  static warn(...args: any[]): void {
    if (this.shouldLog('warn')) {
      console.warn('[WARN]', ...args);
    }
  }

  static error(...args: any[]): void {
    if (this.shouldLog('error')) {
      console.error('[ERROR]', ...args);
    }
  }

  // Optional: Add methods for structured logging with context
  static logWithContext(level: LogLevel, context: Record<string, any>, ...args: any[]): void {
    if (this.shouldLog(level)) {
      const method = console[level] || console.log;
      method(`[${level.toUpperCase()}]`, {context}, ...args);
    }
  }
}

export default Logger;